import React from 'react';
import { LoadingSpinner } from 'components/loading-spinner';

export function LoadingBuffer(props) {
  if (!props.statusCallback(props)) {
    return <LoadingSpinner />;
  }

  return props.children || <div />;
}
